import { orderBy } from 'lodash'

const sortTodaysLeaves = (todaysLeaves = []) => orderBy(todaysLeaves, ['startDate', 'endDate'], ['desc', 'asc'])

export {
  sortTodaysLeaves
}